export default {
  mutations: {
    setIsSidebarOpen (state, flag) {
      state.isSidebarOpen = flag
    },
    toggleSidebar (state) {
      state.isSidebarOpen = !state.isSidebarOpen
    }
  },
  getters: {
    getIsSidebarOpen (state) {
      return state.isSidebarOpen
    }
  },
  state: {
    isSidebarOpen: false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js